import React, {useEffect} from 'react';
import {Row, Col} from 'reactstrap';
import {MODES} from '../Modes';
import CheckBoxComponent from './CheckBoxComponent';
import {TILT_WARNING_INITIAL_POSITIONS} from '../../../../Shared/Constants/TiltWarning/TiltWarning';
import {Flex, Radio, RadioChangeEvent} from 'antd';
import {INPUT_TYPES} from '../../../../Shared/Constants/InputTypes';

interface TiltWarningProps {
	handleIssueAlarmInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, validate?: boolean) => void;
	formSettings: {
		tiltWarningCheckboxDisabled: boolean;
	};
	issueProfile: {
		tilt_warning: boolean;
		tilt_warning_initial_position: {reference_x: number; reference_y: number; reference_z: number};
		tilt_warning_angle: number;
	};
	mode: string;
}

export default function TiltWarningComponent(props: Readonly<TiltWarningProps>) {
	const [selectedPosition, setSelectedPosition] = React.useState(
		Object.values(TILT_WARNING_INITIAL_POSITIONS).find(
			v =>
				v.reference_x === props.issueProfile.tilt_warning_initial_position?.reference_x &&
				v.reference_y === props.issueProfile.tilt_warning_initial_position?.reference_y &&
				v.reference_z === props.issueProfile.tilt_warning_initial_position?.reference_z
		)
	);

	useEffect(() => {
		if (props.issueProfile.tilt_warning_initial_position) {
			const position = Object.values(TILT_WARNING_INITIAL_POSITIONS).find(
				v =>
					v.reference_x === props.issueProfile.tilt_warning_initial_position.reference_x &&
					v.reference_y === props.issueProfile.tilt_warning_initial_position.reference_y &&
					v.reference_z === props.issueProfile.tilt_warning_initial_position.reference_z
			);
			setSelectedPosition(position);
		}
	}, [props.issueProfile.tilt_warning_initial_position]);

	const onChange = (e: RadioChangeEvent) => {
		const position = TILT_WARNING_INITIAL_POSITIONS[e.target.value];
		setSelectedPosition(position);

		props.handleIssueAlarmInputChange(
			{
				target: {
					id: 'tiltWarningInitialPositionId',
					name: 'tilt_warning_initial_position',
					value: e.target.value,
					type: INPUT_TYPES.SELECT,
				},
			} as unknown as React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
			false
		);
	};

	return (
		<>
			<CheckBoxComponent
				id="checkboxTiltWarning"
				name="tilt_warning"
				text="Tilt warning"
				onChange={props.handleIssueAlarmInputChange}
				checked={props.issueProfile.tilt_warning}
				disabled={props.formSettings.tiltWarningCheckboxDisabled}
			/>
			<br />
			<label htmlFor="tiltWarningInitialPositionId">Mounting position</label>
			<Radio.Group
				id="tiltWarningInitialPositionId"
				name="tiltWarningPosition"
				value={selectedPosition?.id}
				disabled={props.mode === MODES.DISPLAY ? true : !props.issueProfile.tilt_warning}
				style={{display: 'flex', flexWrap: 'wrap', gap: '16px'}}
				onChange={onChange}
				options={Object.values(TILT_WARNING_INITIAL_POSITIONS).map(v => ({
					value: v.id,
					label: (
						<Flex gap="small" justify="center" align="center" vertical>
							<img src={`/img/TiltWarning${v.name}.svg`} alt={v.name} style={{width: '100px', height: '100px'}} />
							<span>{v.name}</span>
						</Flex>
					),
				}))}
			/>
			<br />
			<Row>
				<Col xl={3}>
					<label htmlFor="tiltWarningAngle">Warning threshold</label>
					<select
						className="form-control"
						id="tiltWarningAngle"
						name="tilt_warning_angle"
						value={props.issueProfile.tilt_warning_angle}
						onChange={props.handleIssueAlarmInputChange}
						disabled={props.mode === MODES.DISPLAY ? true : !props.issueProfile.tilt_warning}
					>
						{Array.from({length: 12}, (_, i) => (i + 1) * 15).map(angle => (
							<option key={angle} value={angle}>
								{angle}°
							</option>
						))}
					</select>
				</Col>
			</Row>
		</>
	);
}
